export enum GTMSignupTriggers {
  SIGNUP_SUCCESS = 'signup_success_trigger',
  ONBOARDED = 'onboarded_trigger',
}

// PostHog keys off the string values below (see DAT-1176), not the enum member names —
// they stay as originally documented in the PRD's Instrumentation Requirements table
// even though the member names have been updated to match the current tooltip/card UI.
export enum GTMAppInspectorTriggers {
  NUDGE_SHOWN = 'app_inspector_modal_opened',
  NUDGE_DISMISSED = 'app_inspector_modal_skipped',
  TAB_CLICKED = 'app_inspector_tab_clicked',
}

export type GTMEventTriggers = GTMSignupTriggers | GTMAppInspectorTriggers;
